import apiClient from "./ApiService";
import { PATH_PROVINCES } from "../config/env";

export const getProvinces = async()=>{
    return await apiClient.get(PATH_PROVINCES);
}
export default getProvinces;